import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicFileInput } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function ProductOrderUploadTemplate({ productOrderUploadViewStore }) {
    const {
        contentLoading,
        form
    } = productOrderUploadViewStore;

    return (
        <ApplicationEditLayout store={productOrderUploadViewStore}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                    <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                        <BasicFileInput field={form.$('file')} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

ProductOrderUploadTemplate.propTypes = {
    productOrderUploadViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ProductOrderUploadTemplate);
